import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-buttons',
	imports: [SharedModule, ButtonComponent, UiCodeBlockComponent],
	templateUrl: './ui-buttons.component.html',
	styleUrl: './ui-buttons.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiButtonsComponent {
	onButtonClick(_label: string): void {
		// Showcase no-op: the ui-kit only demonstrates the event (onClick).
	}

	generateCode(attrs: {
		label?: string;
		variant?: string;
		icon?: string;
		disabled?: boolean;
		size?: string;
		type?: string;
		routerLink?: string;
	}): string {
		let code = '<app-button';

		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.icon) code += `\n    icon="${attrs.icon}"`;
		if (attrs.variant) code += `\n    variant="${attrs.variant}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.type) code += `\n    type="${attrs.type}"`;
		if (attrs.routerLink) code += `\n    routerLink="${attrs.routerLink}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;

		code += '\n/>';
		return code;
	}
}
